import React, { useState } from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { Link } from 'gatsby';

import { media } from '../helpers';
import Wrapper from '../elements/wrapper';

const MobileMenuContainer = styled(motion.div)`
    position: fixed;
    left: 0;
    width: 100%;
    padding: 0 0 20px;
    border-bottom: 1px solid #000;
    background-color: #f2f0eb;
    z-index: 1000;

    .top-level-nav {
        padding-top: 20px;

        ul {
            display: flex;
            padding: 0;
            margin: 0;
            list-style: none;
            justify-content: space-between;

            li {
                a,
                button {
                    color: #000;
                    font-weight: bold;
                    text-transform: uppercase;
                    text-decoration: none;
                    background-color: transparent;
                    border: none;
                    padding: 0;

                    &.active {
                        color: #f74d33;
                    }
                }
            }
        }
    }
    .shop-menu-container {
        position: fixed;
        top: 63px;
        width: 100%;
        background-color: #f2f0eb;
        height: calc(100vh - 138px);
        padding-top: 20px;

        .back-btn {
            text-align: right;
            padding-right: 20px;

            button {
                color: #f74d33;
                border: none;
                background-color: transparent;
                font-weight: bold;
            }
        }

        .sub-nav-parent {
            &.hide {
                display: none;
            }
            > ul {
                padding: 0;
                margin: 0;
                list-style: none;

                li {
                    padding: 0 20px;
                    ${media.small`padding: 0 40px 0;`}
                    button {
                        background-color: transparent;
                        font-weight: bold;
                        display: block;
                        width: 100%;
                        text-align: left;
                        border: none;
                        border-bottom: 1px solid #000;
                        padding: 20px 0;
                    }
                    a {
                        background-color: #f74d33;
                        color: #fff;
                        font-weight: bold;
                        display: block;
                        width: 100%;
                        text-align: left;
                        border: none;
                        border-bottom: 1px solid #000;
                        padding: 20px 0;
                    }

                    &:nth-last-child(2) {
                        button {
                            border: none;
                        }
                    }

                    &.impact {
                        background-color: #f74d33;
                        a {
                            border: none;
                            text-decoration: none;
                        }
                    }
                }
            }

            .link {
                position: absolute;
                bottom: 0;
                left: 0;
                width: 100%;
                a {
                    display: inline-block;
                    background-color: #f74d33;
                    color: #fff;
                    width: 100%;
                    padding: 20px 0 20px 5vw;
                    font-weight: bold;
                    text-decoration: none;
                }
            }
        }

        .sub-nav-child {
            overflow-y: scroll;
            max-height: 65vh;
            > ul {
                padding: 0 20px 0;
                margin: 0;
                list-style: none;
                ${media.small`padding: 0 40px 0;`}
                li {
                    a {
                        background-color: transparent;
                        font-weight: bold;
                        display: block;
                        width: 100%;
                        text-align: left;
                        border: none;
                        border-bottom: 1px solid #000;
                        padding: 15px 0;
                        text-decoration: none;
                        color: #000;
                    }
                }
            }
        }
    }
`;

const MobileMenu = ({ primaryLinks, subNavLinks, shopAllLinks }) => {
    const [isShopMenuOpen, setIsShopMenuOpen] = useState(false);
    const [subMenuActive, setSubMenuActive] = useState(-1);

    function toggleShopMenu() {
        if (isShopMenuOpen) {
            setIsShopMenuOpen(false);
        } else {
            setIsShopMenuOpen(true);
        }
    }

    function handleSubMenu(index) {
        setSubMenuActive(index);
    }

    return (
        <MobileMenuContainer
            key="content"
            initial="collapsed"
            animate="open"
            exit="collapsed"
            variants={{
                open: { transform: 'translate3d(0, 0%, 0)' },
                collapsed: { transform: 'translate3d(0, -100%, 0)' },
            }}
            transition={{
                duration: 0.5,
            }}
        >
            <Wrapper className="top-level-nav">
                <ul>
                    {primaryLinks &&
                        primaryLinks.map((link, index) => {
                            if (index === 0) {
                                return (
                                    <li key={index}>
                                        <button
                                            className={
                                                isShopMenuOpen ? 'active' : ''
                                            }
                                            onClick={() => toggleShopMenu()}
                                        >
                                            {link.title}
                                        </button>
                                    </li>
                                );
                            } else {
                                return (
                                    <li key={index}>
                                        <Link to={link.url}>{link.title}</Link>
                                    </li>
                                );
                            }
                        })}
                </ul>
            </Wrapper>
            {isShopMenuOpen && (
                <motion.div
                    className="shop-menu-container"
                    initial="collapsed"
                    animate="open"
                    exit="collapsed"
                    variants={{
                        open: {
                            transform: 'translate3d(0%, 0, 0)',
                        },
                        collapsed: {
                            transform: 'translate3d(100%, 0, 0)',
                        },
                    }}
                >
                    <div className="back-btn">
                        {subMenuActive !== -1 && (
                            <button onClick={() => handleSubMenu(-1)}>
                                {' < '}Back
                            </button>
                        )}
                    </div>
                    <motion.div
                        className={
                            subMenuActive === -1
                                ? 'sub-nav-parent'
                                : ' sub-nav-parent hide'
                        }
                    >
                        <ul>
                            {shopAllLinks &&
                                shopAllLinks.map((link, index) => {
                                    return (
                                        <li>
                                            <button
                                                onClick={() =>
                                                    handleSubMenu(index)
                                                }
                                            >
                                                {link.title}
                                            </button>
                                        </li>
                                    );
                                })}
                            <li className="impact">
                                <Link to="/pages/fighting-climate-change">
                                    Impact
                                </Link>
                            </li>
                        </ul>
                    </motion.div>

                    {subNavLinks &&
                        subNavLinks.map((item, index) => {
                            return (
                                <>
                                    {subMenuActive === index && (
                                        <motion.div
                                            className="sub-nav-child"
                                            key="content"
                                            initial="collapsed"
                                            animate="open"
                                            exit="collapsed"
                                            variants={{
                                                open: {
                                                    transform:
                                                        'translate3d(0%, 0, 0)',
                                                },
                                                collapsed: {
                                                    transform:
                                                        'translate3d(100%, 0, 0)',
                                                },
                                            }}
                                            transition={{
                                                duration: 0.5,
                                            }}
                                        >
                                            <ul>
                                                {item.links.map(
                                                    (linkNode, index) => {
                                                        const { title, url } =
                                                            linkNode.link || {};
                                                        return (
                                                            <li key={index}>
                                                                <Link to={url}>
                                                                    {title}
                                                                </Link>
                                                            </li>
                                                        );
                                                    }
                                                )}
                                            </ul>
                                        </motion.div>
                                    )}
                                </>
                            );
                        })}
                </motion.div>
            )}
        </MobileMenuContainer>
    );
};

export default MobileMenu;
